import json2mq from 'json2mq';
import { getInitialValue } from '../utils/activities';
import { getWeekNumber, WEEKNUMBER } from '../utils/date';
import { useMuiMediaQuery } from './useMediaQuery';

export const useGetInitialValue = (weekNumber = WEEKNUMBER) => {
  const isMobile = useMuiMediaQuery(json2mq({ maxWidth: 600 }));
  const lastWeekNumber = getWeekNumber(new Date().toDateString());
  const initialValueDesktop = getInitialValue(weekNumber); // [0, ..., 52]
  const initialValueMobile = getInitialValue(lastWeekNumber); // [0, ..., 15]
  const initialValue = isMobile ? initialValueMobile : initialValueDesktop;

  return {
    initialValue,
  };
};
